function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.33334 1.33325H4.00001C3.26667 1.33325 2.67334 1.93325 2.67334 2.66659L2.66667 13.3333C2.66667 14.0666 3.26 14.6666 3.99334 14.6666H12C12.7333 14.6666 13.3333 14.0666 13.3333 13.3333V5.33325L9.33334 1.33325ZM12 13.3333H4.00001V2.66659H8.66667V5.99992H12V13.3333ZM5.88 8.69992L4.93334 9.63992L7.29334 11.9999L11.0667 8.22659L10.1267 7.28659L7.3 10.1133L5.88 8.69992Z",
  fill: "white"
});

var SvgTask = function SvgTask(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTask, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/task.28ed68e2.svg";
export { ForwardRef as ReactComponent };